function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardStory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-3"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435,
    y: 398.49,
    width: 14.9,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 34.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.44,
    y: 394.37,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.53,
    y: 394.37,
    width: 15.58,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.08,
    y: 391.01,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.57,
    y: 116,
    width: 94.67,
    height: 266.4,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.24,
    y: 116,
    width: 251.01,
    height: 266.4,
    transform: "translate(589.48 498.4) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.57,
    y: 149.33,
    width: 114.67,
    height: 6.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.24,
    y: 149.33,
    width: 251.01,
    height: 6.67,
    transform: "translate(609.48 305.33) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.57,
    y: 189.33,
    width: 114.67,
    height: 6.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.24,
    y: 189.33,
    width: 251.01,
    height: 6.67,
    transform: "translate(609.48 385.33) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.57,
    y: 229.33,
    width: 114.67,
    height: 6.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.24,
    y: 229.33,
    width: 251.01,
    height: 6.67,
    transform: "translate(609.48 465.33) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.57,
    y: 269.33,
    width: 114.67,
    height: 6.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.24,
    y: 269.33,
    width: 251.01,
    height: 6.67,
    transform: "translate(609.48 545.33) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.57,
    y: 309.33,
    width: 114.67,
    height: 6.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.24,
    y: 309.33,
    width: 251.01,
    height: 6.67,
    transform: "translate(609.48 625.33) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.57,
    y: 349.33,
    width: 114.67,
    height: 6.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.24,
    y: 349.33,
    width: 251.01,
    height: 6.67,
    transform: "translate(609.48 705.33) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.13,
    y: 35,
    width: 144,
    height: 71,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.01,
    y: 106,
    width: 12.22,
    height: 10,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.13,
    y: 98.28,
    width: 144,
    height: 7.72,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.13,
    y: 35,
    width: 144,
    height: 7.72,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.74,
    y: 64.6,
    width: 71.39,
    height: 45.06,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.55,
    y: 109.65,
    width: 7.76,
    height: 6.35,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.74,
    y: 104.76,
    width: 71.39,
    height: 4.9,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.74,
    y: 64.6,
    width: 71.39,
    height: 4.9,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.63,
    y: 124.08,
    width: 25.25,
    height: 25.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.88,
    y: 124.08,
    width: 24.42,
    height: 25.25,
    transform: "translate(788.17 273.42) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.63,
    y: 124.08,
    width: 25.25,
    height: 25.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.88,
    y: 124.08,
    width: 24.42,
    height: 25.25,
    transform: "translate(728.17 273.42) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.63,
    y: 124.08,
    width: 25.25,
    height: 25.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.88,
    y: 124.08,
    width: 24.42,
    height: 25.25,
    transform: "translate(668.17 273.42) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.63,
    y: 124.08,
    width: 25.25,
    height: 25.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.88,
    y: 124.08,
    width: 24.42,
    height: 25.25,
    transform: "translate(608.17 273.42) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.52,
    y: 162.77,
    width: 10.58,
    height: 26.56,
    transform: "translate(195.61 352.11) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.29,
    y: 162.77,
    width: 10.23,
    height: 26.56,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.08,
    y: 162.77,
    width: 10.58,
    height: 26.56,
    transform: "translate(220.74 352.11) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.85,
    y: 162.77,
    width: 10.23,
    height: 26.56,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.65,
    y: 162.77,
    width: 10.58,
    height: 26.56,
    transform: "translate(245.87 352.11) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.42,
    y: 162.77,
    width: 10.23,
    height: 26.56,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.21,
    y: 162.77,
    width: 10.58,
    height: 26.56,
    transform: "translate(271.01 352.11) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.99,
    y: 162.77,
    width: 10.23,
    height: 26.56,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.17,
    y: 291.44,
    width: 14.24,
    height: 17.89,
    transform: "translate(216.58 600.78) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.4,
    y: 291.44,
    width: 13.77,
    height: 17.89,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.09,
    y: 291.44,
    width: 14.24,
    height: 17.89,
    transform: "translate(250.42 600.78) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.32,
    y: 291.44,
    width: 13.77,
    height: 17.89,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.01,
    y: 291.44,
    width: 14.24,
    height: 17.89,
    transform: "translate(284.26 600.78) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.24,
    y: 291.44,
    width: 13.77,
    height: 17.89,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.93,
    y: 291.44,
    width: 14.24,
    height: 17.89,
    transform: "translate(318.09 600.78) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.16,
    y: 291.44,
    width: 13.77,
    height: 17.89,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.6,
    y: 204.08,
    width: 13.99,
    height: 25.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.59,
    y: 204.08,
    width: 13.53,
    height: 25.25,
    transform: "translate(786.72 433.42) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.97,
    y: 204.08,
    width: 13.99,
    height: 25.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.97,
    y: 204.08,
    width: 13.53,
    height: 25.25,
    transform: "translate(753.46 433.42) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.34,
    y: 204.08,
    width: 13.99,
    height: 25.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.34,
    y: 204.08,
    width: 13.53,
    height: 25.25,
    transform: "translate(720.21 433.42) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.72,
    y: 204.08,
    width: 13.99,
    height: 25.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.71,
    y: 204.08,
    width: 13.53,
    height: 25.25,
    transform: "translate(686.96 433.42) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.34,
    y: 204.08,
    width: 13.99,
    height: 25.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.33,
    y: 204.08,
    width: 13.53,
    height: 25.25,
    transform: "translate(614.2 433.42) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.71,
    y: 204.08,
    width: 13.99,
    height: 25.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.71,
    y: 204.08,
    width: 13.53,
    height: 25.25,
    transform: "translate(580.95 433.42) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.09,
    y: 204.08,
    width: 13.99,
    height: 25.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.08,
    y: 204.08,
    width: 13.53,
    height: 25.25,
    transform: "translate(547.69 433.42) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.46,
    y: 204.08,
    width: 13.99,
    height: 25.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.45,
    y: 204.08,
    width: 13.53,
    height: 25.25,
    transform: "translate(514.44 433.42) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.69,
    y: 291.45,
    width: 34.1,
    height: 17.83,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.78,
    y: 291.45,
    width: 32.97,
    height: 17.83,
    transform: "translate(760.54 600.72) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.17,
    y: 291.45,
    width: 34.1,
    height: 17.83,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.27,
    y: 291.45,
    width: 32.97,
    height: 17.83,
    transform: "translate(679.52 600.72) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.66,
    y: 291.45,
    width: 34.1,
    height: 17.83,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.76,
    y: 291.45,
    width: 32.97,
    height: 17.83,
    transform: "translate(598.49 600.72) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.15,
    y: 291.45,
    width: 34.1,
    height: 17.83,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.25,
    y: 291.45,
    width: 32.97,
    height: 17.83,
    transform: "translate(517.47 600.72) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 208.71,
    cy: 178.08,
    r: 11.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.71,
    cy: 178.08,
    r: 11.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 268.71,
    cy: 178.08,
    r: 11.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.71,
    cy: 178.08,
    r: 11.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.19,
    cy: 261.92,
    r: 7.42,
    transform: "translate(-57.82 27.27) rotate(-13.28)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.97,
    cy: 261.92,
    r: 7.42,
    transform: "translate(-57.29 31.81) rotate(-13.28)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.75,
    cy: 261.92,
    r: 7.42,
    transform: "translate(-163.12 279.71) rotate(-67.5)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.52,
    cy: 261.92,
    r: 7.42,
    transform: "translate(-141.99 181.03) rotate(-45)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 332.88,
    cy: 341.63,
    r: 7.71,
    transform: "translate(-110.13 518.44) rotate(-67.5)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 353.43,
    cy: 341.63,
    r: 7.71,
    transform: "matrix(0.97, -0.23, 0.23, 0.97, -69.04, 90.34)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373.98,
    cy: 341.63,
    r: 7.71,
    transform: "translate(-84.76 556.41) rotate(-67.5)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.53,
    cy: 341.63,
    r: 7.71,
    transform: "translate(-72.07 575.39) rotate(-67.5)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 343.46,
    cy: 330.87,
    r: 7.71,
    transform: "translate(-133.36 339.77) rotate(-45)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 364.01,
    cy: 330.87,
    r: 7.71,
    transform: "translate(-80.97 540.55) rotate(-67.5)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384.56,
    cy: 330.87,
    r: 7.71,
    transform: "matrix(0.97, -0.23, 0.23, 0.97, -65.73, 97.2)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 233.1,
    cy: 341.63,
    r: 7.71,
    transform: "translate(-173.29 264.89) rotate(-45)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 253.65,
    cy: 341.63,
    r: 7.71,
    transform: "translate(-159.04 445.24) rotate(-67.5)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274.2,
    cy: 341.63,
    r: 7.71,
    transform: "translate(-71.15 72.14) rotate(-13.28)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.75,
    cy: 341.63,
    r: 7.71,
    transform: "translate(-133.67 483.2) rotate(-67.5)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 243.68,
    cy: 330.87,
    r: 7.71,
    transform: "translate(-155.26 429.38) rotate(-67.5)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.23,
    cy: 330.87,
    r: 7.71,
    transform: "translate(-156.57 283.75) rotate(-45)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.78,
    cy: 330.87,
    r: 7.71,
    transform: "translate(-129.89 467.35) rotate(-67.5)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.96 249.2 382.61 269.33 353.01 269.33 376.96 249.2",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.96 249.2 366.67 269.33 397.9 269.33 376.96 249.2",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.15 249.2 335.8 269.33 306.19 269.33 330.15 249.2",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.15 249.2 319.86 269.33 351.09 269.33 330.15 249.2",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.33 249.2 288.99 269.33 259.38 269.33 283.33 249.2",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.33 249.2 273.04 269.33 304.28 269.33 283.33 249.2",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.7 209.78 87.55 229.33 104.06 229.33 90.7 209.78",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.7 209.78 96.44 229.33 79.02 229.33 90.7 209.78",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.81 209.78 113.66 229.33 130.17 229.33 116.81 209.78",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.81 209.78 122.55 229.33 105.13 229.33 116.81 209.78",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.92 209.78 139.76 229.33 156.28 229.33 142.92 209.78",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.92 209.78 148.66 229.33 131.24 229.33 142.92 209.78",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.52 249.2 242.17 269.33 212.57 269.33 236.52 249.2",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.52 249.2 226.23 269.33 257.47 269.33 236.52 249.2",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-3",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--cash-register--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292,285.69h82.79a6.37,6.37,0,0,1,6.37,6.37h0a6.37,6.37,0,0,1-6.37,6.37H292Z",
    style: {
      fill: "#53266A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,285.69h82.79a6.37,6.37,0,0,1,6.37,6.37h0a6.37,6.37,0,0,1-6.37,6.37H292Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 366.68,
    cy: 245.97,
    r: 9.57,
    transform: "translate(43.05 546.33) rotate(-76.72)",
    style: {
      fill: "#53266A"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 366.68,
    cy: 245.97,
    r: 9.57,
    transform: "translate(43.05 546.33) rotate(-76.72)",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "300.81 247.25 379.92 247.25 372.34 285.69 308.38 285.69 300.81 247.25",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.6,243.56h83.52a1.18,1.18,0,0,1,1.14,1.51l-1,3.41a1.19,1.19,0,0,1-1.14.85H299.59a1.19,1.19,0,0,1-1.14-.85l-1-3.41A1.18,1.18,0,0,1,298.6,243.56Z",
    style: {
      fill: "#53266A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.6,243.56h83.52a1.18,1.18,0,0,1,1.14,1.51l-1,3.41a1.19,1.19,0,0,1-1.14.85H299.59a1.19,1.19,0,0,1-1.14-.85l-1-3.41A1.18,1.18,0,0,1,298.6,243.56Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.53,
    y: 239,
    width: 38,
    height: 4.56,
    style: {
      fill: "#53266A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.53,
    y: 239,
    width: 38,
    height: 4.56,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.36,251.88a1.23,1.23,0,0,1-1.33.84c-3-.51-4.48-3.24-3.39-6.53l7.65-23.09c1.21-3.65,5.16-6.61,8.8-6.61h13.55c3.64,0,5.62,3,4.42,6.61l-6.79,20.46H351l6.78-20.46c.8-2.39-.5-4.34-2.89-4.34H341.34a6.61,6.61,0,0,0-5.78,4.34l-7.65,23.09c-.65,1.95.1,3.61,1.69,4.15a1.21,1.21,0,0,1,.76,1.54Z",
    style: {
      fill: "#53266A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.34,
    y: 240.62,
    width: 146.1,
    height: 175.62,
    rx: 8.65,
    style: {
      fill: "#53266A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.9,306.22H86.9a6.38,6.38,0,0,0-6.37,6.38h0A6.37,6.37,0,0,0,86.9,319h120Z",
    style: {
      fill: "#53266A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.9 322.5 171.49 338.53 171.49 318.96 206.9 318.96 206.9 322.5",
    style: {
      fill: "#263238",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.9,306.22H130.47a6.38,6.38,0,0,0-6.37,6.38h0a6.38,6.38,0,0,0,6.37,6.37H206.9Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.24,
    y: 240.62,
    width: 106.2,
    height: 175.62,
    rx: 8.65,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.94,
    y: 318.97,
    width: 10.85,
    height: 97.27,
    style: {
      fill: "#53266A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.94,
    y: 318.97,
    width: 10.85,
    height: 97.27,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.79 323.19 127.94 325.54 127.94 318.96 138.79 318.96 138.79 323.19",
    style: {
      fill: "#53266A",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.18,
    y: 261.38,
    width: 86.31,
    height: 32.73,
    rx: 2.47,
    style: {
      fill: "#53266A",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.49 223.41 100.19 223.41 94.18 306.23 165.5 306.23 159.49 223.41",
    style: {
      fill: "#53266A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.06 223.41 100.19 223.41 94.18 306.23 110.14 306.23 108.06 223.41",
    style: {
      fill: "#263238",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.45,233.51c-5.54,0-10.5-3.89-11.33-9.07a9.19,9.19,0,0,1,1.84-7.15,10.64,10.64,0,0,1,7.47-3.93c5.95-.54,11.51,3.51,12.39,9a9.21,9.21,0,0,1-1.85,7.16,10.6,10.6,0,0,1-7.46,3.93C134.15,233.49,133.8,233.51,133.45,233.51Zm-.95-18.44c-.3,0-.61,0-.91,0a8.91,8.91,0,0,0-6.24,3.26,7.46,7.46,0,0,0-1.49,5.8c.73,4.61,5.44,8,10.49,7.54a8.91,8.91,0,0,0,6.24-3.26,7.46,7.46,0,0,0,1.49-5.8C141.39,218.32,137.19,215.07,132.5,215.07Z",
    style: {
      fill: "#53266A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129,233.51c-.35,0-.7,0-1.06,0a10.6,10.6,0,0,1-7.46-3.93,9.16,9.16,0,0,1-1.84-7.16c.87-5.5,6.43-9.55,12.38-9a10.62,10.62,0,0,1,7.47,3.93,9.15,9.15,0,0,1,1.84,7.15C139.47,229.62,134.5,233.51,129,233.51Zm1-18.44c-4.7,0-8.9,3.25-9.59,7.58a7.46,7.46,0,0,0,1.49,5.8,8.91,8.91,0,0,0,6.24,3.26c5.05.45,9.76-2.93,10.5-7.54a7.42,7.42,0,0,0-1.5-5.8,8.89,8.89,0,0,0-6.23-3.26C130.52,215.08,130.22,215.07,129.92,215.07Z",
    style: {
      fill: "#53266A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.41,
    y: 110.56,
    width: 17.6,
    height: 130.07,
    style: {
      fill: "#53266A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.01 180.2 218.41 180.2 218.41 214.19 236.01 212.02 236.01 180.2",
    style: {
      fill: "#263238",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.01 111.45 218.41 111.45 218.41 121.34 236.01 119.17 236.01 111.45",
    style: {
      fill: "#263238",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.25,204.39l-4.91-71.25a4.39,4.39,0,0,1,4.38-4.69H290.13a4.38,4.38,0,0,1,4.38,4.08l4.9,71.25a4.38,4.38,0,0,1-4.38,4.69H185.62A4.37,4.37,0,0,1,181.25,204.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.87,131.7H182.16a2.48,2.48,0,0,0-2.47,2.65l4.72,68.56a2.48,2.48,0,0,0,2.47,2.31H293.59a2.48,2.48,0,0,0,2.48-2.65L291.35,134A2.48,2.48,0,0,0,288.87,131.7Z",
    style: {
      fill: "#53266A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.87,131.7H182.16a2.48,2.48,0,0,0-2.47,2.65l4.72,68.56a2.48,2.48,0,0,0,2.47,2.31H293.59a2.48,2.48,0,0,0,2.48-2.65L291.35,134A2.48,2.48,0,0,0,288.87,131.7Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.29,
    y: 238.24,
    width: 93.66,
    height: 2.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "263.88 197.19 193.4 197.19 189.49 140.43 259.97 140.43 263.88 197.19",
    style: {
      fill: "#53266A",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.03 145.51 265.04 145.51 264.69 140.43 283.68 140.43 284.03 145.51",
    style: {
      fill: "#53266A",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.43 165.98 266.44 165.98 265.45 151.5 284.44 151.5 285.43 165.98",
    style: {
      fill: "#53266A",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.98,
    y: 90.11,
    width: 35.41,
    height: 26.43,
    style: {
      fill: "#53266A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.98,
    y: 90.11,
    width: 14.73,
    height: 26.43,
    style: {
      fill: "#263238",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.8,203.81l1.95-2.49a3.67,3.67,0,0,1,3.07-1.4l5.56.25a6.91,6.91,0,0,1,5.46,3.15l.74,1.16c-3,4.35-9.37,6.87-9.37,6.87l-1.74.92a3.06,3.06,0,0,1-4.19-1.19l-1.87-3.44A3.52,3.52,0,0,1,320.8,203.81Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.15,153.94c.58.71,1,1.21,1.42,1.81s.84,1.15,1.25,1.72c.82,1.16,1.57,2.34,2.32,3.52a83.56,83.56,0,0,1,4,7.38c.62,1.26,1.18,2.56,1.75,3.86s1.05,2.63,1.51,4a64.47,64.47,0,0,1,2.32,8.33l.11.46a4.47,4.47,0,0,1,.1,1,14.31,14.31,0,0,1-1,5.22,18.59,18.59,0,0,1-2.15,3.89,26.29,26.29,0,0,1-5.18,5.24,39.5,39.5,0,0,1-5.58,3.58,40.46,40.46,0,0,1-6,2.59,3.77,3.77,0,0,1-3.87-6.25l.25-.24c1.23-1.23,2.65-2.56,3.88-3.86a46.89,46.89,0,0,0,3.44-3.95,18,18,0,0,0,2.35-3.75c.5-1.12.44-2,.29-2l.21,1.42c-.75-2.16-1.55-4.3-2.52-6.43s-2-4.22-3.16-6.3-2.35-4.12-3.64-6.12c-.64-1-1.3-2-2-3l-1-1.44-.92-1.3-.24-.34a7.5,7.5,0,0,1,11.94-9.05Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.43,145.46c-2.82,6.4-2.64,14.39,6,26.61,5.74.63,16.36-6.83,16.36-6.83S341.5,144.79,326.43,145.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.62,123.21c-1.67,6.2-3.73,17.56.29,21.69,0,0-5.87-.88-18.33,6.83-3.61-5.18-.93-6.83-.93-6.83,7-1.65,7.24-6.77,6.39-11.59Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.26,149.51c1.85-4,6.21-7.81,9.22-7.24s4.84,1.51,6.62,0,6.18-3.71,8.42-1.22c3.15,3.48,7.92,1,6.12,4.81C324.7,150,296.26,149.51,296.26,149.51Z",
    style: {
      fill: "#53266A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.09,111.83c-.12.85-.66,1.51-1.2,1.47s-.88-.76-.76-1.61.66-1.5,1.2-1.46S299.22,111,299.09,111.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.56,110.29l-1.9-.73S297.45,111.22,298.56,110.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.91,113.43a25,25,0,0,1-3.74,5.19c.95,1.12,2.88.78,2.88.78Z",
    style: {
      fill: "#ff5652"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.68,105.09a.5.5,0,0,1-.06-.36.51.51,0,0,1,.62-.33,5.2,5.2,0,0,1,3.6,2.92.44.44,0,0,1-.31.6.54.54,0,0,1-.65-.31,4.17,4.17,0,0,0-2.88-2.28A.56.56,0,0,1,297.68,105.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.92,110.77c-1.89,10-2.47,14.27-8.18,19.07-8.59,7.23-20.4,3.41-21.52-6.8-1-9.18,2.23-24,12.54-27.31A13,13,0,0,1,326.92,110.77Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.5,114c-3.62-5.67-7.54-12.75-5.08-17.67s8.05-3.75,8.05-3.75S318.3,86.5,328,94.42c12.86,10.53-.93,22.12-4.34,32.16C319.89,137.63,300.45,124.25,304.5,114Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.92,95.62c-5.23-19.45-28.17-10.51-34.84,1l2.72.71c27.37-17.66,13.89,7.87,14.12,18.28s10.55,16.82,10.55,16.82S365.14,115.06,359.92,95.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353,130c-2.92,0-7-.55-9.66-3.24-2.4-2.43-3.15-6.14-2.21-11,.3-1.54.78-3.35,1.28-5.26,1.58-6,3.55-13.38.45-16-2.18-1.85-6.77-1.2-13.65,1.91a.24.24,0,0,1-.33-.12.25.25,0,0,1,.13-.33c7.16-3.25,11.8-3.85,14.17-1.84,3.34,2.82,1.42,10.09-.28,16.51-.51,1.9-1,3.7-1.28,5.23-.9,4.72-.2,8.28,2.08,10.59,4.25,4.3,12.69,2.84,12.78,2.82a.25.25,0,1,1,.08.5A22.94,22.94,0,0,1,353,130Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.39,92.34c.25-1.27-2.95-.74-3.1.39s-.57.5-1.82,2.15-1.42,3.59,2.68,4.87c2.6.81,3-1.19,4.33-2.19.73-.54,1.55-.82,2.08-1.23a.83.83,0,0,0-.42-1.48C330.46,94.71,328.13,93.59,328.39,92.34Z",
    style: {
      fill: "#53266A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.34,117.56a7,7,0,0,1-4.42,3.54c-2.35.52-3.24-2.19-2.35-4.83.8-2.36,3-5.49,5.24-4.81S307.61,115.27,306.34,117.56Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.13,421.17c7.77-1.16,7.92-2.45,12.09-3.91,3.57-1.26,4.57-1.08,7.45-2.05,2.41-.81,1.59-3.1,0-5.54-.79-1.22-.91-2.38-1.78-4.55l-11.81,1.75c-1.14,3.3-1.55,7.52-8.29,9.93C342.78,418.24,346,421.63,349.13,421.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.11,421.2c7.73,0,9.21-.51,13.56-.66,3.72-.13,4.33.66,8.1.66,2.5,0,2.85-2.82,1.93-4.93-.71-1.64-.82-3.61-1.34-5.74H288.71c-1.92,3.37-7.16,5.87-13,6.29C271.51,417.13,274,421.2,277.11,421.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.14,210.63s-1.54,55.58,1.76,90.88c-.21,33.13.81,109,.81,109,.26,1.69,9.14,1,10.65,0,0,0,16.65-55.27,9.26-109,18.49-56.06,14.5-90.88,14.5-90.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.23,210.63s18.06,62.73,25.38,93.54c7.7,32.35,30.58,81.26,32.48,102.7,2,.79,8.39-.09,11.81-1.75,0,0-3.13-68.37-21.73-99.52,4.2-76.64-16.6-95-16.6-95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.55,402.58a31.15,31.15,0,0,1,.23,4.43.93.93,0,0,0,.93,1c4.42,0,10.53-1.88,12.46-2.54a.9.9,0,0,0,.62-.85l0-4.19a.93.93,0,0,0-1.08-.91l-12.44,2.09A.9.9,0,0,0,353.55,402.58Z",
    style: {
      fill: "#53266A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.49,405.86c0,1.15-.1,3.2-.21,4.71a1,1,0,0,0,.85,1,63.24,63.24,0,0,0,11.75-.13.86.86,0,0,0,.77-.7l.8-4.13a1,1,0,0,0-.91-1.13L288.4,405A.86.86,0,0,0,287.49,405.86Z",
    style: {
      fill: "#53266A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.74,160.68a190.58,190.58,0,0,0,.28,19.41c.33,8.43.91,16.72,2.12,30.54h42.43c-.85-11.95.54-25.57,8.16-52.46a9.9,9.9,0,0,0-8.46-12.87c-1.68-.17-3.47-.31-5.3-.4a135.92,135.92,0,0,0-19.26,0c-2.1.19-4.27.46-6.34.75A16,16,0,0,0,283.74,160.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.36,205.38c-8.49,2.17-21.41,2.79-42.62.53.51,11.25-4.44,86.9-4.44,86.9s43,9.45,67.31-3.38C350.18,232.26,328.36,205.38,328.36,205.38Z",
    style: {
      fill: "#53266A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.13,251s11.67-10.87,17.43-18.29C329.1,240.49,322.15,247.47,312.13,251Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.75,160.62l2.82,1.43a3.68,3.68,0,0,1,2,2.74l.83,5.5a6.86,6.86,0,0,1-2,6l-1,1c-4.84-2.06-8.56-7.85-8.56-7.85l-1.24-1.53a3.06,3.06,0,0,1,.35-4.35l3-2.5A3.52,3.52,0,0,1,247.75,160.62Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.4,161.62c-.31.86-.54,1.46-.81,2.15s-.56,1.31-.84,2c-.56,1.3-1.18,2.55-1.81,3.8a77.75,77.75,0,0,1-4.22,7.28c-.76,1.18-1.57,2.34-2.39,3.49s-1.7,2.27-2.63,3.36a62.67,62.67,0,0,1-5.92,6.3l-.28.27a5.1,5.1,0,0,1-.83.64,11.43,11.43,0,0,1-4,1.54,12.6,12.6,0,0,1-3.58.14,18.08,18.08,0,0,1-5.26-1.46,33,33,0,0,1-7.23-4.55,57.38,57.38,0,0,1-5.66-5.3,60.53,60.53,0,0,1-4.87-5.86,3.76,3.76,0,0,1,5.1-5.36l.17.11c1.86,1.21,3.83,2.53,5.75,3.71s3.86,2.33,5.76,3.3a26.3,26.3,0,0,0,5.36,2.17,4.07,4.07,0,0,0,1.67.16c.13,0,.12-.1,0-.1a1.56,1.56,0,0,0-.68.18l-1.1.92c1.46-1.76,2.88-3.56,4.19-5.49s2.58-3.91,3.75-6,2.31-4.15,3.36-6.29c.53-1.06,1-2.14,1.53-3.21l.71-1.6.64-1.45.17-.38a7.5,7.5,0,0,1,13.93,5.53Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.54,145.49c-6.93.9-13.67,5.2-19.64,18.94,2.44,5.24,14.32,10.47,14.32,10.47S306.92,158,298.54,145.49Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardStory);
export default __webpack_public_path__ + "static/media/dashboard-story.5f5120b9d307ad12e43162900883113d.svg";
export { ForwardRef as ReactComponent };